export const PhoneAnalyticsQueryKeys = {
  base: ['phoneAnalytics'] as const,

  charts: (query?: string) => [...PhoneAnalyticsQueryKeys.base, 'charts', query],
};
